import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {reise:String}

  connect() {
    this.debounce(this.fetchData, 300) // Adjust timing as needed
  }

  debounce(callback, delay) {
    let timer
    this.fetchData = () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        callback.apply(this)
      }, delay)
    }
  }

  fetcha(event) {
    const value = event.target.value // merkmaltyp_id
    const reise = this.reiseValue //reise_id
    // neue route mit beiden parametern
    fetch(`/merkmale_lookup/${reise}/${value}`, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
    .then(response => response.text())
    .then(html => {
      document.getElementById("merkmal").innerHTML = html
    })
  }
}  

